<template>
	<Page v-if="data" ref="page" :type="data.type" :slug="data.metadata.slug" :name="data.name" :metadata="data.metadata" :transition-enter="onEnter" :transition-leave="onLeave">
		<Article v-bind="data" />
	</Page>
</template>

<script setup>
import { Page } from '@/components/core'
import { Article } from '@/components/pages'
import { article } from '~/sanity/pages/'

import { pageTransition } from '~/transitions/page'
import { useTransition } from '~/composables/core'

const route = useRoute()
const { category, slug } = route.params

const query = article(category, slug)
const page = ref(null)

const { data, error } = await usePreviewSanityQuery(query)

if (error.value) {
	throw showError({
		statusCode: error.value?.statusCode || 500,
		statusMessage: error.value?.message || 'An error occurred',
	})
}

if (!data.value) {
	throw showError({
		statusCode: 404,
		statusMessage: 'Page not found',
	})
}

const { onEnter, onLeave } = useTransition()

definePageMeta({
	pageTransition,
	robots: 'noindex, nofollow',
})
</script>
